import { zodResolver } from "@hookform/resolvers/zod";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import FormEngine, { FormEngineProps } from "@components/FormEngine/FormEngine";
import PasswordCriteria from "@components/PasswordCriteria/PasswordCriteria";

import { regex } from "@utils/zod";

export const CODE_VERIFICATION_FORM_ID = "code-verification-form";
type CodeVerificationProps = {
  resendCode: () => void;
  onSubmit: FormEngineProps["onSubmit"];
};

const CodeVerification = ({ onSubmit, resendCode }: CodeVerificationProps) => {
  const [showCriteria, setShowCriteria] = useState(false);
  const form = useForm({
    resolver: zodResolver(zodValidation),
    defaultValues: {
      verificationCode: "",
      password: "",
      confirmPassword: "",
    },
  });

  return (
    <>
      <Typography variant="body1">
        Verify your email and create a password.
      </Typography>
      <Typography variant="body1">
        <Link
          onClick={resendCode}
          variant="body1"
          underline="none"
          sx={{ fontSize: "inherit", cursor: "pointer" }}
        >
          Resend verification code
        </Link>
      </Typography>
      <FormEngine
        formController={form}
        formId={CODE_VERIFICATION_FORM_ID}
        onSubmit={onSubmit}
        schema={[
          {
            name: "verificationCode",
            label: "Verification Code",
            type: "input",
            fieldProps: {
              formatterRules: ["numbers"],
            },
          },
          {
            name: "password",
            label: "Password",
            type: "password",
            fieldProps: {
              onFocus: () => setShowCriteria(true),
              onBlur: () => setShowCriteria(false),
            },
          },
          {
            name: "criteria",
            type: "custom",
            component: () => (
              <PasswordCriteria
                password={form.watch("password")}
                showCriteria={showCriteria}
              />
            ),
          },
          {
            name: "confirmPassword",
            label: "Confirm Password",
            type: "password",
          },
        ]}
      />
    </>
  );
};

const zodValidation = z
  .object({
    verificationCode: z.string().regex(/^[0-9]+$/),
    password: regex.password,
    confirmPassword: regex.password,
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: "custom",
        message: "The passwords do not match.",
        path: ["confirmPassword"],
      });
    }
  });
export default CodeVerification;
